module.exports = __webpack_public_path__ + "static/img/patho-cerumen-high-CyKZGANK.c59b4411.png";